export default __webpack_public_path__ + "static/media/Group1497-Rotate@3x.654f7c91.png";